<template>
  <v-card class="transparent pa-5" flat>
    <v-row dense align="center">
      <v-col cols="1" align="center" >
        <v-avatar color="_blue" size="40">
          <img v-if="isAvatar" :src="data.avatarPath" alt="picture" />
          <span v-else class="_light_grey--text headline">{{ photoWord }}</span>
        </v-avatar>
      </v-col>
      <v-col><div :class="`${data.color}--text`">{{ data.name }}</div></v-col>
    </v-row>
    <v-row dense>
      <v-col cols="1"></v-col>
      <v-col>
        <v-card cols="11" class="mx-auto" :color="data.color">
          <v-card-text class="_light_grey--text pa-2 d-flex flex-column" :style="{ whiteSpace: 'pre-line' }">
            <span class="align-self-start text-subtitle-1">{{ data.text }}</span>
            <span class="text-caption font-italic align-self-end">{{ new Date(data.time).toLocaleString() }}</span>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: 'CardBig',
  props: {
    data: { type: Object, required: true },
  },
  components: {},
  data: () => ({
    discount: {},
  }),
  computed: {
    isAvatar() {
      return this.data.avatarPath !== '';
    },
    photoWord() {
      return this.data.name[0];
    },
  },
  created() {
  },
  methods: {
  },
};
</script>
